import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { useSingleCache } from '@/data/hook/query/v2/useCacheManager';
import { coursePathsQueryKeys } from '@/data/services/querykeys';
import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import CoursePath from '@/models/CoursePath';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const usePedWorkspace = () => {
  const {
    courseLineId: courseLineParam,
    moduleId: moduleParam,
    slug,
  } = useParams();
  const isNew = slug === 'new';
  const courseLineId = Number(courseLineParam);
  const moduleId = Number(moduleParam);

  const coursePathQueryKey = coursePathsQueryKeys.get(slug ?? '');

  const { data: coursePath, isInitialLoading: isLoadingCoursePath } = useQuery({
    ...coursePathQueryKey,
    enabled: !!slug && !isNew,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const cache = useSingleCache<CoursePath>(coursePathQueryKey.queryKey);

  const isLoading = isLoadingCoursePath && !!slug;

  const isEditing = coursePath?.status === VersioningStatusEnum.EDITING;
  const isPublished = coursePath?.status === VersioningStatusEnum.PUBLISHED;
  const isLimitedEdition = isEditing || isPublished;

  return {
    coursePath,
    courseLineId,
    moduleId,
    slug,
    isLoading,
    cache,
    isEditing,
    isPublished,
    isLimitedEdition,
  };
};

export default usePedWorkspace;
